import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import Money from 'common/components/money';
import { isProjectTagline } from 'project/utils';

export default class RevisionDisclosures extends Component {
  renderContent() {
    const { revision, entry, canViewAssetPrice, project } = this.props;

    /* image entries */
    if (entry.entry_type == 'image') {
      if (revision.is_entirely_original) {
        return <div>This design is entirely original.</div>;
      }

      if (!canViewAssetPrice) {
        return <div>This design contains 3rd-party work.</div>;
      }

      const fontsPrice = revision.additional_costs.fonts;
      const imagesPrice = revision.additional_costs.images;

      return (
        <div>
          <div>
            My design contains items that you will need to license from third parties.
            This will cost you extra, as follows:
          </div>
          <ul>
            { (fontsPrice || fontsPrice === 0) &&
            <li>Font(s): <Money value={fontsPrice} /></li> }

            { (imagesPrice || imagesPrice === 0) &&
            <li>Image(s): <Money value={imagesPrice} /></li> }
          </ul>
        </div>);
    }

    /* name entries that are not from tagline projects */
    if (entry.entry_type == 'name' && !isProjectTagline(project)) {
      return (
        <div>The .com URL is {!revision.domain_available? "not":""} available for this name.</div>
      );
    }

    return null;
  }

  render(){
    const content = this.renderContent();

    if (!content) {
      return null;
    }

    return (
      <div className={classnames("disclosure", this.props.extraClasses)}>
        <h5>Disclosures:</h5>
        { content }
      </div>);
  }
}

RevisionDisclosures.propTypes = {
  project: PropTypes.object.isRequired,
  entry: PropTypes.object.isRequired,
  revision: PropTypes.object.isRequired,
  canViewAssetPrice: PropTypes.bool
};



// WEBPACK FOOTER //
// ./entries/components/revision_disclosures.jsx